import { memo } from 'react';
import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { CheckboxGroup, FormField } from '@library';
import type { MultipleChoiceComponent } from '../../../types/customStoryblokComponents';

interface MultipleChoiceProps {
    params: MultipleChoiceComponent;
}

const MultipleChoice = ({
    params: { label, items, required, name, _uid },
}: MultipleChoiceProps) => {
    return (
        <Controller
            name={name || _uid}
            render={({ field, fieldState: { error } }) => (
                <FormField
                    label={label}
                    error={
                        error?.message ? (
                            <FormattedMessage id={error.message} />
                        ) : undefined
                    }
                >
                    <div tabIndex={0} ref={field.ref}>
                        <CheckboxGroup
                            readonly={field.disabled}
                            direction="column"
                            options={items}
                            value={field.value || []}
                            onChange={
                                !field.disabled ? field.onChange : undefined
                            }
                        />
                    </div>
                </FormField>
            )}
            rules={{ required: required ? 'this field is required' : false }}
        />
    );
};

export default memo(MultipleChoice);
